module.exports = __webpack_public_path__ + "public/img/moneyshoukuan.ef4c1992.png";